export const ANALYTICS_SOURCE_WEB = 'web';
export const ANALYTICS_SOURCE_AI_CHAT = 'ai-chat';

export type DataQuerySource = typeof ANALYTICS_SOURCE_WEB | typeof ANALYTICS_SOURCE_AI_CHAT;
